import React, { useRef } from "react";
import Swal from "sweetalert2";
import { domain } from "../../../Urls/Services/Api_urls";
import Dashboard from "../Dashboard";
import Swalgeneral from "../../../Landing/General/Swalgeneral";
/**
 * The above code is a JavaScript function that allows users to send emails with different types of
 * messages to specified email addresses.
 * @returns The code is returning a React component that renders a form for sending emails to users.
 * The form includes input fields for email and type of message, as well as a submit button.
 */
export const Sendemail = () => {
  const opciones = [
    { value: "", label: "Seleccione una opción" },
    {
      value: "send_email_activate_account",
      label: "Activación de cuenta",
    },
    { 
      value: "send_email_unified_sale", 
      label: "Activación de cuenta venta unificada"
    },
    {
      value: "resend_activation_tv_email",
      label: "Reenviar correo de activación de EMTV+"
    }
  ];
  const token = window.sessionStorage.getItem("token");
  const emailRef = useRef(null);
  const tmessageRef = useRef(null);

  let objeto,
    objeto1 = [];

  /**
   * The handleSubmit function is an asynchronous function that handles form submission by sending an
   * email to a user using the provided email address and displaying a success or error message based
   * on the response from the server.
   * @param e - The parameter `e` is an event object that represents the event that triggered the form
   * submission. In this case, it is used to prevent the default form submission behavior using
   * `e.preventDefault()`.
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = emailRef.current.value;
    const typeMessage = tmessageRef.current.value;
    const url = domain + "/user/send_mail/?func=" + tmessageRef.current.value;
    const credentials = {
      email: emailRef.current.value,
    };

    // Alerta para que el usuario escoja un tipo de correo
    if (!typeMessage) {
      Swal.fire({
        title: "Seleccione el tipo de correo a enviar",
        icon: "warning",
        showConfirmButton: false,
        timer: 2000,
      });
      return;
    }

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(credentials),
      });

      const respuesta = await response.json();
      if (response.status === 200) {
        Swal.fire({
          title: "Se ha enviado el correo al usuario",
          text: "Informale al usuario que ingrese a su correo",
          icon: "success",
          showCancelButton: false,
          allowOutsideClick: false,
          confirmButtonColor: "#655CC9",
          showConfirmButton: true,
          confirmButtonText: "Ok",
        });
      } else {
        objeto = respuesta;
        Swal.fire({
          title: objeto.detail,
          footer: respuesta.msg,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        footer: "Fallo en el servidor",
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  return (
    <div>
        <Dashboard
        MInicio={""}
        Msolicitudes={""}
        Mservicios={""}
        Mcompra={""}
        Mcunyompra={""}
        Mempaquetar={""}
        Mcpotenciales={"active"}
        Madminportal={""}
        Mcampaña={""}
        Mtv={""}
      >
      <section className="flex justify-center items-center min-h-screen p-4">
        <div className="w-full max-w-2xl bg-white rounded-2xl p-6 shadow-lg">
          <h2 className="text-xl font-bold text-center mb-6">
            Reenvío de correos para los usuarios
          </h2>

          <form className="space-y-4">
            <div className="flex flex-col">
              <label htmlFor="email" className="font-medium mb-1">
                Email
              </label>
              <input
                id="email"
                name="Email"
                type="text"
                ref={emailRef}
                placeholder="Email"
                required
                className="w-full h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="flex flex-col">
              <label htmlFor="typeMessage" className="font-medium mb-1">
                Tipo de correo
              </label>
              <select
                id="typeMessage"
                ref={tmessageRef}
                className="w-full h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {opciones.map((opcion) => (
                  <option key={opcion.value} value={opcion.value}>
                    {opcion.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex justify-center">
              <button
                type="button"
                onClick={handleSubmit}
                className="w-full max-w-xs h-12 bg-colorprimary text-white font-semibold rounded-[40px] flex justify-center items-center"
              >
                Enviar
              </button>
            </div>
          </form>
        </div>
      </section>
      </Dashboard>
    </div>
  );
};
